import { Pipe, PipeTransform } from '@angular/core';
import { stepValidator } from '@components/form/components/form-layout-2/config';
import { ValueType } from '@shared/components/form-item/model';

@Pipe({
  name: 'isStepVisible',
  standalone: true,
})
export class IsStepVisiblePipe implements PipeTransform {
  transform(step: number, form: Record<string, ValueType>): boolean {
    for (const prop of stepValidator[step]!) {
      if (!form[prop]) {
        return false;
      }
    }
    return true;
  }
}
